import UserProfile from "@/ts/User/Types/UserProfile";
import ApiClient from "@/ts/Utility/ApiClient";
import UserAchievements from "@/ts/User/Types/UserAchievements";
import UserSubscription from "@/ts/User/Types/UserSubscription";
import TripDayBookPreview from "@/ts/DayBook/Type/TripDayBookPreview";
import CreatedDesiresDayBook from "@/ts/DayBook/Type/CreatedDayBook/CreatedDesiresDayBook";
import UpdatedUserProfile from "@/ts/User/Types/UpdatedUserProfile";
import {AccountType} from "@/ts/User/Types/AccountType";

export default class UserService {
    private static hasPro = false;
    private static defaultProfile: UserProfile | null = null;

    static async getProfile(): Promise<UserProfile> {
        const profile = await ApiClient.get<UserProfile>('user/profile');
        this.hasPro = profile.is_premium;
        this.defaultProfile = profile
        return profile
    }

    static getDefaultProfile(): UserProfile | null {
        return this.defaultProfile;
    }

    static isPro(): boolean {
        return this.hasPro;
    }

    static getDefaultAccountType(): AccountType {
        return (this.hasPro ? AccountType.Premium : AccountType.Free) as AccountType;
    }

    static async updateProfile(data: UpdatedUserProfile, avatar: File | null = null): Promise<UserProfile> {
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        if (avatar) {
            formData.append('avatar', avatar);
        }
        return await ApiClient.post<UserProfile>('user/profile', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
    }

    static async getAchievements(): Promise<UserAchievements> {
        return await ApiClient.get<UserAchievements>('user/achievements');
    }

    static async getSubscription(): Promise<UserSubscription> {
        return await ApiClient.get<UserSubscription>('user/subscription');
    }

    static async saveTimeZone(timeZone: string): Promise<void> {
        await ApiClient.post('user/timezone', {timeZone});
    }
}
